import StepModernization from './StepModernization'
import type { StepModernizationDetail, StepModernizationItem } from './StepModernization'

export default StepModernization
export type { StepModernizationDetail, StepModernizationItem }
